import styled from "styled-components";

const StyledCategoryFormModal = styled.div`
    .sb-create-category-modal {
        &__footer {
            .sb-button {
                &__inner {
                    padding: 0;
                }
            }
        }
    }
`;

export default StyledCategoryFormModal;
